const westAmc = {
  isIntegrated(customerNumber) {
    return `/homeowner/cases/${customerNumber}/west-amc/is-integrated`;
  },
  OnHold(controlIdNumber) {
    return `/homeowner/cases/${controlIdNumber}/west-amc/hold/on`;
  },
  OffHold(controlIdNumber) {
    return `/homeowner/cases/${controlIdNumber}/west-amc/hold/off`;
  },
};

export default westAmc;